
import { useMemo } from "react";
import _flatten from "lodash/flatten";
interface props{
    features:any
}

export function useKeyInfomation(features){
    const keyInfo = useMemo(() => {
        const allowedFeatures = [
                'anchor_tenants',
                'ownership',
                'num_units',
                'parking',
                'viewing',
                'legal',
                'max_people',
                'min_people',
                'total_workstations',
                'nearest_airport',
                'nearest_road_link',
                'nearest_train_station',
                'nearest_underground',
                'parking_spaces',
                'transit_zone',
                'additional',
                'available_space',
                'design_life',
                'design_type',
                'goods_lift_weight',
                'passenger_lift_weight',
                'history',
                'leisure_facilities',
                'number_of_floors',
                'occupancy_levels',
                'total_size',
                'terms'
          ]
          let data = [
              
          ]
    
          Object.keys(features).map((key) => {
              if(allowedFeatures.includes(key)){
                  data.push(
                      {
                          title:features[key].label,
                          value:features[key].value
                      }
                  )
              }
          })
    
          return data;
      },[features])
    
    return {
        keyInfo:keyInfo
    }
}